// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__C5Noo"};